// src/api/fetchWeather.js
import axiosClient from './axiosClient';

/**
 * Fetches the current weather information.
 *
 * @param {object} params
 * @param {number} params.latitude - Latitude coordinate.
 * @param {number} params.longitude - Longitude coordinate.
 * @returns {Promise<{ message: string }>} Returns an object containing the weather message.
 */
export async function fetchWeather({ latitude, longitude }) {
  const response = await axiosClient.get(
    `/weather/today?latitude=${latitude}&longitude=${longitude}`
  );
  return response.data;
}
